
import { Card, List, Typography } from "antd";
import React from "react";

// Mock formatFieldName function
const formatFieldName = (key) => {
  return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};

const ListChart = ({ listingChart, chartinfo }) => {
  return (
    <Card
      size="small"
      style={{
        borderRadius: 4,
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.08)",
        border: "1px solid #e8e8e8",
        margin: "0 auto",
      }}
      bodyStyle={{ padding: 0 }}
     >
       <div
        style={{
          backgroundColor: "#06A786",
          color: "white",
          padding: "6px 10px",
          borderRadius: "4px 4px 0 0",
          marginBottom: 0,
        }}
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
            color: "white",
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          {chartinfo?.chart_title || "Ship Detail"}
        </Typography.Title>
      </div>

      {/* Compact Body Section */}
      <div style={{ padding: "8px" }}>
        <List
          size="small"
          dataSource={listingChart}
          split={false}
          style={{ margin: 0, padding: 0 }}
          renderItem={(item, index) => (
            <List.Item
              style={{
                padding: 0,
                margin: 0,
                border: "none",
                borderBottom:
                  index === listingChart.length - 1
                    ? "none"
                    : "1px solid #f5f5f5",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                  padding: "2px 0",
                  minHeight: "20px"
                }}
              >
                <Typography.Text
                  style={{
                    color: "#404040",
                    fontSize: "12px",
                    fontWeight: 500,
                    margin: 0,
                    padding: 0,
                  }}
                >
                  {formatFieldName(item.key)}
                </Typography.Text>

                <Typography.Text
                  style={{
                    color:
                      item.key === "imo_number"
                        ? "black"
                        : item.key === "owner_code"
                          ? "#262626"
                          : "#666",
                    fontSize: "12px",
                    fontWeight: item.key === "name" ? 600 : 400,
                    margin: 0,
                    padding: item.key === "imo_number" ? "2px 6px" : 0,
                    backgroundColor:
                      item.key === "imo_number" ? "#D4F5DE" : "transparent",
                    borderRadius:
                      item.key === "imo_number" || item.key === "owner_code"
                        ? "3px"
                        : 0,
                    textAlign: "right",
                  }}
                >
                  {/* Special handling for flag field */}
                  {item.key === "flag" ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <div
                        style={{
                          width: 12,
                          height: 8,
                          backgroundColor: "#bfbfbf",
                          border: "1px solid #d9d9d9",
                          borderRadius: 1,
                        }}
                      />
                      <span>{item.value}</span>
                    </div>
                  ) : (
                    item.value
                  )}
                </Typography.Text>
              </div>
            </List.Item>
          )}
        />
      </div>
    </Card>
  );
};

export default ListChart;
